import { datadogRum } from '@datadog/browser-rum';
import { getConfig } from './utils/config';

// Use of require so nodejs can access a folder outside its scope
// eslint-disable-next-line @typescript-eslint/no-var-requires
const pjson = require('../package.json');

async function initDataDog() {
  const config = await getConfig();
  // Start DataDog RUM if the application id and client token exist
  // in the environment. These DD_ vars should be set in Vault.
  const {
    DD_APPLICATION_ID,
    DD_CLIENT_TOKEN,
    DD_ENV,
    DD_TRACK_USER_INTERACTIONS,
    DD_TRACK_RESOURCES,
    DD_TRACK_LONG_TASKS,
  } = config;
  if (DD_APPLICATION_ID && DD_CLIENT_TOKEN) {
    // eslint-disable-next-line no-console
    console.log('Initializing DataDog...');
    // See https://docs.datadoghq.com/real_user_monitoring/browser/
    datadogRum.init({
      service: pjson.name,
      version: pjson.version,
      clientToken: DD_CLIENT_TOKEN,
      applicationId: DD_APPLICATION_ID,
      env: DD_ENV ?? 'dev',
      trackUserInteractions: (DD_TRACK_USER_INTERACTIONS ?? 'true') === 'true',
      trackResources: (DD_TRACK_RESOURCES ?? 'true') === 'true',
      trackLongTasks: (DD_TRACK_LONG_TASKS ?? 'true') === 'true',
    });
  } else {
    // eslint-disable-next-line no-console
    console.log(
      'No applicationId and/or clientToken found in process.env. Could not initialize DataDog...',
    );
  }
}

initDataDog();
